import { uuidv4 } from 'ProdantixSdk/core/uuid';
import { DEFAULT_MASK_OPTIONS, type MaskOptions } from 'ProdantixSdk/web/replay/mask';
import { SessionRecorder } from 'ProdantixSdk/web/replay/recorder';

export type { MaskOptions } from 'ProdantixSdk/web/replay/mask';
export { SessionRecorder } from 'ProdantixSdk/web/replay/recorder';

export interface SessionReplayOptions {
  apiKey: string;
  distinctId: () => string;
  flushIntervalMs?: number;
  mask?: Partial<MaskOptions>;
  maxEvents?: number;
  now?: () => number;
  onError?: (error: unknown) => void;
  replayHost: string;
  sessionId?: string;
}

/** Starts session replay: capture the DOM + interactions (inputs masked by default)
 *  and stream chunks to the recorder service. Returns the recorder so the caller can
 *  `stop()` it. A missing `sessionId` gets a fresh v4 uuid. */
export function installSessionReplay(options: SessionReplayOptions): SessionRecorder {
  const recorder = new SessionRecorder({
    apiKey: options.apiKey,
    distinctId: options.distinctId,
    flushIntervalMs: options.flushIntervalMs ?? 5000,
    mask: { ...DEFAULT_MASK_OPTIONS, ...options.mask },
    maxEvents: options.maxEvents ?? 200,
    now: options.now ?? (() => Date.now()),
    onError: options.onError,
    replayHost: options.replayHost,
    sessionId: options.sessionId ?? uuidv4(),
  });
  recorder.start();
  return recorder;
}
